"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var bind_1 = require("@reverbdotcom/commons/dist/bind");
var api_request_1 = require("./api_request");
var PromoCodeRedemptionForm = /** @class */ (function (_super) {
    tslib_1.__extends(PromoCodeRedemptionForm, _super);
    function PromoCodeRedemptionForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            code: '',
            error: '',
            disabled: false,
        };
        return _this;
    }
    PromoCodeRedemptionForm.prototype.updateCode = function (evt) {
        this.setState({ code: evt.target.value });
    };
    PromoCodeRedemptionForm.prototype.onSubmit = function (evt) {
        var _this = this;
        evt.preventDefault();
        this.setState({ disabled: true });
        return api_request_1.V3.postJSON(this.props.postURL, {
            discount_code: this.state.code,
            payment_method: this.props.paymentMethod,
            checkout_uuid: this.props.checkoutUUID,
        }).then(function (res) {
            if (res.redirect) {
                window.location = res.redirect;
            }
            else {
                _this.handleError(res);
            }
        }).fail(this.handleError);
    };
    PromoCodeRedemptionForm.prototype.handleError = function (res) {
        var error = res.message || I18n.t('discovery.promoCodeRedemptionForm.genericError');
        this.setState({
            error: error,
            disabled: false,
        });
    };
    PromoCodeRedemptionForm.prototype.submitValue = function (disabled) {
        if (disabled) {
            return I18n.t('discovery.wait');
        }
        return I18n.t('discovery.promoCodeRedemptionForm.submit');
    };
    PromoCodeRedemptionForm.prototype.renderAffirmWarning = function () {
        if (!this.props.showAffirmWarning)
            return null;
        return (React.createElement("h4", { className: "mt-space", "data-affirm-warning": true }, I18n.t('discovery.promoCodeRedemptionForm.affirmWarning')));
    };
    PromoCodeRedemptionForm.prototype.render = function () {
        return (React.createElement("div", { className: "module" },
            React.createElement("h3", { className: "heading-3 mb-1" }, I18n.t('discovery.promoCodeRedemptionForm.header')),
            React.createElement("div", { className: "mb-1", "data-promo-code-error": true }, this.state.error),
            React.createElement("form", { onSubmit: this.onSubmit },
                React.createElement("div", { className: "g-container" },
                    React.createElement("div", { className: "g-col-9" },
                        React.createElement("input", { type: "text", name: "discount_code", id: "discount_code", placeholder: I18n.t('discovery.promoCodeRedemptionForm.placeholder'), className: "checkout-coupon-code wide", value: this.state.code, onChange: this.updateCode }),
                        this.renderAffirmWarning()),
                    React.createElement("div", { className: "g-col-3" },
                        React.createElement("input", { type: "submit", className: "btn btn-blue wide", value: this.submitValue(this.state.disabled), disabled: this.state.disabled }))))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], PromoCodeRedemptionForm.prototype, "updateCode", null);
    tslib_1.__decorate([
        bind_1.default
    ], PromoCodeRedemptionForm.prototype, "onSubmit", null);
    tslib_1.__decorate([
        bind_1.default
    ], PromoCodeRedemptionForm.prototype, "handleError", null);
    return PromoCodeRedemptionForm;
}(React.Component));
exports.default = PromoCodeRedemptionForm;
//# sourceMappingURL=promo_code_redemption_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/promo_code_redemption_form.js
// module id = vpyl
// module chunks = 20 21